export interface WorkHistoryModel {
    WorkId: string;
    Id: number ;
    EventDate: string;
    EventId: number;
    EventName: string ;
    EventUser: string;
    StatusId: number;
    StatusName: string ;
    Detail: string;
    Allocation: string;
}

export class WorkHistoryFrameModel {
    count : number ;
    page : number ;
    pagesize : number ;
    data : WorkHistoryModel[] ;
}

export class WorkHistoryDtoModel {
    "@odata.context" : number ;
    "@odata.count" : number ;
    value : WorkHistoryModel[] ;
}
